import mongoose, { Schema } from 'mongoose';
import { PaymentStatus } from '../constants';

const coinDetails = new Schema(
  {
    // coin code eth, btc, etc
    code: {
      type: String,
      required: true,
    },
    // how many coins to pay
    coinsValue: {
      type: Number,
      required: true,
    },
    // conversion rate
    rate: {
      type: Number,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
  },
  { _id: false },
);

const cryptoPayment = new Schema(
  {
    coinDetails: {
      type: [coinDetails],
      required: true,
      default: undefined,
    },
    fiatValue: {
      type: Number,
      required: true,
    },
    user: {
      type: Schema.Types.ObjectId,
      ref: 'User',
      required: true,
    },
    serviceGroup: {
      type: Schema.Types.ObjectId,
      ref: 'ServiceGroup',
      required: true,
    },
    status: {
      type: String,
      default: 'pending',
      enum: Object.values(PaymentStatus),
    },
    finishedAt: {
      type: Date,
    },
  },
  { timestamps: true },
);

export default cryptoPayment;
